import React from 'react';
import cx from 'classnames';

import useUniqueId from '../../utils/useUniqueId';
import styles from './ListGroup.module.scss';

export interface Props {
  /** Children of the ListGroup -- can be ListItems or other elements that can take ListItems as children or props */
  children?: React.ReactNode;
  /** CSS className for the List.Group container */
  className?: Parameters<typeof cx>[0];
  /** A JSX element (html tag or React component) to show at the top of the ListGroup */
  header?: React.ReactNode;
  /** A CSS class to apply to the individual ListItems within the ListGroup */
  listItemClassName?: Parameters<typeof cx>[0];
}

export const ListGroup: React.FC<Props> = ({
  children,
  className,
  header,
  listItemClassName,
  ...restProps
}) => {
  const listItemChildBase = useUniqueId('list-item');

  return (
    <div className={cx(styles.listGroup, className)} {...restProps}>
      {header && header}
      {children &&
        React.Children.map(
          children,
          (child, idx) =>
            React.isValidElement(child) &&
            React.cloneElement(child, {
              ...child.props,
              className: listItemClassName,
              key: `${listItemChildBase}-${idx}`,
            }),
        )}
    </div>
  );
};

ListGroup.displayName = 'ListGroup';

export default ListGroup;
export { styles };
